<template>
  <div
    class="c-map-wrapper"
    :class="{
      'c-map-wrapper--full': fillSpace || fullscreen,
      'c-map-wrapper--large': isLarge,
      'c-map-wrapper--ios': $store.getters.os === 'ios',
      'c-map-wrapper--android': $store.getters.os === 'android'
    }"
  >
    <div class="c-map" ref="map" />
    <div class="c-map-buttons c-map-buttons--top" v-if="fullscreenButton">
      <div class="c-map-buttons__right">
        <a
          href="#"
          class="c-map-button"
          @click.prevent="toggleFullscreen"
          v-if="fullscreenButton"
        >
          <o-icon :icon="fullscreen ? 'fullscreen-exit' : 'fullscreen'" />
        </a>
      </div>
    </div>
    <div class="c-map-buttons" v-if="centerButton || filterButton">
      <div class="c-map-buttons__left">
        <a
          href="#"
          class="c-map-button c-map-button--center"
          @click.prevent="centerMap"
          v-if="centerButton"
        >
          <o-icon icon="current-location" />
        </a>
        <label class="c-map-button c-map-button--dropdown" v-if="filterButton">
          <o-icon icon="filter" />
          <select name="filter">
            <option selected>Alle aanbieders</option>
            <option>Aanbieder 1</option>
            <option>Aanbieder 2</option>
            <option>Aanbieder 3</option>
          </select>
        </label>
      </div>
      <div class="c-map-buttons__right"><slot name="buttonsRight" /></div>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
export default {
  name: 'OMap',
  props: {
    fillSpace: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    markers: {
      type: Array,
      default: () => []
    },
    centerButton: {
      type: Boolean,
      default: true
    },
    filterButton: {
      type: Boolean,
      default: true
    },
    fullscreenButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      map: null,
      fullscreen: false
    }
  },
  watch: {
    fullscreen() {
      setTimeout(() => {
        this.map.resize()
      }, 100)
    }
  },
  methods: {
    centerMap() {
      this.map.flyTo({
        center: [3.718, 51.052]
      })
    },
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen
    },
    goToDetails() {
      this.$router.push({ name: 'poibluebike' })
    }
  },
  mounted() {
    mapboxgl.accessToken =
      'pk.eyJ1Ijoic2ltb253dXl0cyIsImEiOiIyYUF2emFnIn0.9t0p174WT_yVr--kgv4gzw'
    this.map = new mapboxgl.Map({
      container: this.$refs.map,
      center: [3.718, 51.052],
      zoom: 14,
      style: 'mapbox://styles/simonwuyts/cjnysknac066r2slu05j87cre',
      attributionControl: false
    })

    this.map.dragRotate.disable()
    this.map.touchZoomRotate.disableRotation()

    // this.map.on('load', () => {
    //   this.map.addLayer({
    //     id: 'route',
    //     type: 'line',
    //     source: {
    //       type: 'geojson',
    //       data: {
    //         type: 'FeatureCollection',
    //         features: [
    //           {
    //             type: 'Feature',
    //             geometry: {
    //               type: 'LineString',
    //               coordinates: [
    //                 [3.7230241298675537, 51.052570422765626],
    //                 [3.7232172489166255, 51.053534836503985],
    //                 [3.7232601642608647, 51.05360902134427],
    //                 [3.723388910293579, 51.05363599762037],
    //                 [3.723539113998413, 51.053602277272795],
    //                 [3.723828792572021, 51.053568556900665],
    //                 [3.7240970134735103, 51.053568556900665],
    //                 [3.724451065063476, 51.053602277272795],
    //                 [3.7247943878173824, 51.053811343031946],
    //                 [3.7251698970794673, 51.05408110390713],
    //                 [3.725556135177612, 51.05445202254464]
    //               ]
    //             }
    //           }
    //         ]
    //       }
    //     },
    //     layout: {
    //       'line-join': 'round',
    //       'line-cap': 'round'
    //     },
    //     paint: {
    //       'line-color': '#E20914',
    //       'line-width': 3
    //     }
    //   })
    // })

    // Add current location marker

    const currentLocationMarker = document.createElement('div')
    currentLocationMarker.className = 'c-map-current-location'

    const currentLocationMarkerDot = document.createElement('div')
    currentLocationMarkerDot.className = 'c-map-current-location__dot'

    const currentLocationMarkerRipple = document.createElement('div')
    currentLocationMarkerRipple.className = 'c-map-current-location__ripple'

    currentLocationMarker.appendChild(currentLocationMarkerRipple)
    currentLocationMarker.appendChild(currentLocationMarkerDot)

    new mapboxgl.Marker(currentLocationMarker)
      .setLngLat([3.718, 51.052])
      .addTo(this.map)

    // Add markers
    if (this.markers.length > 0) {
      this.markers.forEach(marker => {
        const markerElement = document.createElement('div')
        markerElement.classList.add('c-map-marker')

        if (typeof marker.type !== 'undefined') {
          markerElement.classList.add('c-map-marker--' + marker.type)
        }

        if (typeof marker.status !== 'undefined') {
          markerElement.classList.add('c-map-marker--' + marker.status)
        }

        // Show bike details if type is bluebike
        if (marker.type === 'bluebike') {
          markerElement.addEventListener('click', this.goToDetails, false)
        }

        new mapboxgl.Marker(markerElement)
          .setLngLat(marker.coordinates)
          .addTo(this.map)
      })
    }
  }
}
</script>

<style lang="scss">
.c-map-wrapper {
  box-shadow: 0 0.1rem 0 rgba(#000, 0.1);
  height: 24rem;
  position: relative;
}

.c-map-wrapper--large {
  height: 32rem;
}

.c-map-wrapper--full {
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;

  &.c-map-wrapper--ios {
    height: calc(100% - 4.4rem);
    top: 4.4rem;
  }

  &.c-map-wrapper--android {
    height: calc(100% - 5.6rem);
    top: 5.6rem;
  }
}

.c-map {
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.c-map-current-location {
  position: relative;
  height: 1.6rem;
  width: 1.6rem;
}

.c-map-current-location__dot {
  background: $primary-color;
  background: var(--primary-color);
  border: 0.2rem solid #fff;
  box-shadow: 0 0.2rem 1rem 0 rgba(#000, 0.3);
  border-radius: 50%;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

@keyframes ripple {
  0% {
    opacity: 0.5;
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    transform: scale(5);
  }
}

.c-map-current-location__ripple {
  animation: ripple 2s ease-out infinite both;
  background: $blue;
  border-radius: 50%;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.c-map-marker {
  background: $primary-color;
  background: var(--primary-color);
  background-position: center center;
  background-repeat: no-repeat;
  border: 0.2rem solid #fff;
  border-radius: 50%;
  box-shadow: $box-shadow;
  box-shadow: 0 0.2rem 1rem 0 rgba(#000, 0.3);
  cursor: pointer;
  height: 2.8rem;
  position: absolute;
  width: 2.8rem;
}

.c-map-marker--bluebike {
  background-color: #4aade9;
  background-image: url('/icons/bluebike.svg');
}

.c-map-marker--velo {
  background-color: #f5ae37;
  background-image: url('/icons/velo.svg');
}

.c-map-marker--mobit {
  background-color: #1ea539;
  background-image: url('/icons/mobit.svg');
}

.c-map-marker--nmbs {
  background-color: #e9f1f5;
  background-image: url('/icons/nmbs.svg');
}

.c-map-marker--delijn {
  background-color: #f5f3e9;
  background-image: url('/icons/delijn.svg');
}

.c-map-marker--tec {
  background-color: #fbf4f4;
  background-image: url('/icons/tec.svg');
}

.c-map-marker--bparking {
  background-color: #f5f8f9;
  background-image: url('/icons/bparking.svg');
}

.c-map-marker--4411 {
  background-color: #ebeee8;
  background-image: url('/icons/4411.png');
}

.c-map-marker--officeonwheels {
  background-color: #79c6da;
  background-image: url('/icons/officeonwheels.svg');
}

.c-map-marker--cambio {
  background-color: #ff5c00;
  background-image: url('/icons/cambio.svg');
}

.c-map-marker--waterbus {
  background-color: #bc0d26;
  background-image: url('/icons/waterbus.svg');
}

.c-map-marker--unavailable {
  filter: saturate(0);
  opacity: 0.5;
}

.c-map-buttons {
  background-image: linear-gradient(
    to bottom,
    rgba(#000, 0) 33%,
    rgba(#000, 0.03) 64%,
    rgba(#000, 0.1) 100%
  );
  bottom: 0;
  display: flex;
  left: 0;
  padding: 1.6rem;
  pointer-events: none;
  position: absolute;
  right: 0;
  z-index: 5;

  & > * {
    pointer-events: auto;
  }
}

.c-map-buttons--top {
  background-image: linear-gradient(
    to top,
    rgba(#000, 0) 33%,
    rgba(#000, 0.03) 64%,
    rgba(#000, 0.1) 100%
  );
  bottom: auto;
  top: 0;
}

.c-map-buttons__right {
  margin-left: auto;
}

.c-map-button {
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0.1rem 0 rgba(#000, 0.05), 0 0.1rem 1rem rgba(#000, 0.1);
  color: $primary-color;
  color: var(--primary-color);
  display: inline-flex;
  height: 3.2rem;
  width: 3.2rem;

  .c-icon {
    flex: none;
    margin: auto;
  }

  & + & {
    margin-left: 0.8rem;
  }
}

.c-map-button--dropdown {
  position: relative;

  select {
    appearance: none;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
